import * as R from 'remeda';
import { Message } from '@rossum/api-client/shared';
import { findDatapointById } from '../../../../redux/modules/datapoints/navigation/findDatapointIndex';
import { AnyDatapointDataST } from '../../../../types/datapoints';

export const getErrors = (
  messagesObject: Record<number, Message[]> & { all?: Message[] } & {
    annotation?: Message[];
  }
) =>
  Object.values(messagesObject).flatMap(messages =>
    messages.flatMap(message =>
      message?.type === 'error' && typeof message.id === 'string'
        ? [
            {
              id:
                message.id === 'all'
                  ? ('all' as const)
                  : message.id === 'annotation'
                    ? ('annotation' as const)
                    : parseInt(message.id, 10),
              content: message.content,
            },
          ]
        : []
    )
  );

export const getUniqErrorMessages = (
  messages: ReturnType<typeof getErrors>,
  datapoints: AnyDatapointDataST[]
) => {
  // Uniqe by datapoint label is being performed because of the multivalues
  // (taking message for one column instead of all column rows)
  // It will now ignore messages with the same label across annotation/global/datapoint levels
  // Here's hoping people don't have stupid setups :crossed-fingers:
  return R.uniqueBy(
    messages.flatMap(m => {
      const label =
        m.id === 'all'
          ? 'Global'
          : m.id === 'annotation'
            ? 'Annotation'
            : findDatapointById(datapoints, m.id)?.schema?.label;
      return label ? [{ ...m, label }] : [];
    }),
    msg => msg.label
  );
};
